import { ThemeUICSSObject } from 'theme-ui';
import { getColorsAndStatesByPath, getOneColorState } from '../../methods';
/* IMPORT HERE */

const iconInput: ThemeUICSSObject = {
  '&.iconInput[class]': {
    display: 'flex',
    justifyContent: 'stretch',
    alignItems: 'center',
    border: '1px solid',
    borderColor: 'palette.border.field',
    borderRadius: 'default',
    gap: '0px',

    '&.readOnly, &.readonly': {
      '.iconButton': {
        borderLeft: '1px solid',
        borderLeftColor: 'palette.border.section',
      },
    },

    ':focus-within': {
      outlineColor: 'outlineColor',
      outlineWidth: '3px',
      outlineOffset: '-3px',
      outlineStyle: 'solid',
      borderColor: 'transparent',
    },

    '.iconButton': {
      display: 'flex',
      width: '50px',
      flexShrink: 0,
      height: '50px',
      border: 'none',
      boxShadow: 'none',

      ...getColorsAndStatesByPath('buttons.outline'),

      background: 'palette.background.paper',

      '&:focus': {
        outline: 'none',
        background: (theme) =>
          getOneColorState(
            theme.palette.background.paper,
            'hover',
            theme.palette,
          ),
      },
    },

    '&.disabled, &.disabled:hover': {
      '.iconButton': {
        backgroundColor: 'form.fields.disabled.backgroundColor',
        color: 'palette.text.primary',
        border: 'none',
        cursor: 'not-allowed',
        borderLeft: '1px solid',
        borderLeftColor: 'palette.border.field',
      },
    },

    input: {
      height: '50px',
      width: '100%',
      border: 'none',

      '&:focus': {
        outline: 'none',
      },
    },
  },
};

export default iconInput;
